<template>
  <h4>Disclosures</h4>
  <div class="disclaimer-modal">
    <p>
      <strong>Fraud Notice</strong><br />
      Any person who, with intent to defraud or knowing that he is facilitating
      a fraud against an insurer, submits an application or files a claim
      containing a false or deceptive statement is guilty of insurance fraud.
    </p>
    <p>
      <strong>Notice of Cancellation</strong><br />
      The insurer may elect to cancel coverage at any time during the first 60
      days (59 days in Minnesota, 120 days in South Carolina) following issuance
      of the coverage for any reason which is not specifically prohibited by the
      statute.
    </p>
  </div>
</template>
